import { render, staticRenderFns } from "./VehicleTheft.vue?vue&type=template&id=3f224039&"
import script from "./VehicleTheft.vue?vue&type=script&lang=js&"
export * from "./VehicleTheft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports